/**
 * SOLFIE — "Complete seu pedido" no CARRINHO (drawer e página /cart).
 *
 * Usa a MESMA estrutura visual da lista da PDP (`solfie-ad__list` /
 * `solfie-ad__item`, estilos em assets/solfie-ad.css): foto, nome, preço e um
 * switch. Marcar o switch ADICIONA ao carrinho na hora; desmarcar remove.
 *
 * Quem recomendar é a Shopify (`/recommendations/products.json`); aqui só
 * escolhemos a base (o último item do carrinho) e desenhamos a lista.
 *
 * Regras que evitaram bugs (ver docs/bugs-carrinho-e-abas-2026-09-16.md):
 *   - o ponto de montagem entra como ULTIMO filho de .cart-drawer__items /
 *     .cart-page__items, nunca como irmão do resumo: o morph do tema casa filhos
 *     por POSIÇÃO e fundiria o widget com o `.cart-drawer__summary`;
 *   - nada é desenhado com o carrinho vazio nem quando o drawer está no estado
 *     "carrinho vazio" (senão a lista aparece embaixo de "O carrinho está vazio").
 */
(function () {
  'use strict';

  var cfg = document.getElementById('solfie-upsell-config');
  if (!cfg) return;
  if (cfg.dataset.enabled === 'false') return;

  var TITULO = cfg.dataset.title || 'Complete seu pedido';
  var SUB = cfg.dataset.subtitle || '';
  var INTENT = cfg.dataset.intent || 'complementary';
  var SELO = cfg.dataset.badge || '';
  var SELO_MODO = cfg.dataset.badgeModo || 'desconto';
  var LINK_TEXTO = cfg.dataset.linkText || 'Ver detalhes';
  var MOEDA = cfg.dataset.currency || 'BRL';
  var LOCALE = cfg.dataset.locale || 'pt-BR';

  var estado = { carrinho: null, base: null, buscando: false };

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      var m = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
      return m[c];
    });
  }

  function dinheiro(centavos) {
    try {
      return (centavos / 100).toLocaleString(LOCALE, { style: 'currency', currency: MOEDA });
    } catch (e) {
      return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
    }
  }

  function comLargura(url, largura) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + largura;
  }

  function varianteDe(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].available) return vs[i];
    }
    return vs.length ? vs[0] : null;
  }

  function temDesconto(p, v) {
    var preco = v ? v.price : p.price;
    var de = v ? v.compare_at_price : p.compare_at_price;
    return !!de && de > preco;
  }

  function pctDesconto(p, v) {
    var preco = v ? v.price : p.price;
    var de = v ? v.compare_at_price : p.compare_at_price;
    if (!de || de <= preco) return 0;
    return Math.round(((de - preco) / de) * 100);
  }

  /* ---------- carrinho ---------- */

  function lerCarrinho() {
    return window
      .fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { estado.carrinho = cart; return cart; });
  }

  function chaveDaVariante(variantId) {
    var achou = null;
    ((estado.carrinho && estado.carrinho.items) || []).forEach(function (i) {
      if (String(i.variant_id) === String(variantId)) achou = i.key;
    });
    return achou;
  }

  function noCarrinho(productId) {
    var achou = false;
    ((estado.carrinho && estado.carrinho.items) || []).forEach(function (i) {
      if (String(i.product_id) === String(productId)) achou = true;
    });
    return achou;
  }

  function avisar() {
    if (!estado.carrinho) return;
    document.querySelectorAll('[data-cart-count], .cart-bubble__count').forEach(function (el) {
      el.textContent = estado.carrinho.item_count;
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: estado.carrinho } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: estado.carrinho } }));
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: estado.carrinho,
          sourceId: 'solfie-ad-carrinho',
          data: { source: 'solfie-ad-carrinho', itemCount: estado.carrinho.item_count, didError: false }
        }
      })
    );
  }

  /* ---------- recomendacoes ---------- */

  function recomendar(productId, intent) {
    var url =
      '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
      '&limit=8&intent=' + encodeURIComponent(intent);
    return window
      .fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
  }

  function escolherProduto() {
    var itens = (estado.carrinho && estado.carrinho.items) || [];
    if (!itens.length) return Promise.resolve(null);

    var base = String(itens[itens.length - 1].product_id);
    estado.base = base;

    var primeira = INTENT === 'complementary' ? 'complementary' : 'related';

    return recomendar(base, primeira)
      .then(function (lista) {
        if (!lista.length && primeira !== 'related') return recomendar(base, 'related');
        return lista;
      })
      .then(function (lista) {
        for (var i = 0; i < lista.length; i++) {
          var p = lista[i];
          if (String(p.id) === base) continue;
          if (noCarrinho(p.id)) continue;
          if (!p.available) continue;
          return p;
        }
        return null;
      });
  }

  /* ---------- markup (mesma estrutura da lista da PDP) ---------- */

  function selo(p, v) {
    if (!SELO || SELO_MODO === 'nunca') return '';
    if (SELO_MODO === 'desconto' && !temDesconto(p, v)) return '';
    return '<span class="solfie-ad__selo">' + esc(SELO) + '</span>';
  }

  function item(p) {
    var v = varianteDe(p);
    var desconto = pctDesconto(p, v);
    var capa = comLargura(p.featured_image || (p.images || [])[0], 240);
    var titulo = esc(p.title);

    var precos = '<span class="solfie-ad__price">' + esc(dinheiro(v ? v.price : p.price)) + '</span>';
    if (desconto > 0) {
      precos += '<span class="solfie-ad__compare">' + esc(dinheiro(v.compare_at_price)) + '</span>';
    }

    return (
      '<label class="solfie-ad__item" data-role="item" data-price="' + (v ? v.price : p.price) +
      '" data-variant-id="' + (v ? v.id : '') + '">' +
      '<input type="checkbox" class="solfie-ad__input" data-role="toggle" value="' + (v ? v.id : '') + '">' +
      '<span class="solfie-ad__media">' +
      (capa
        ? '<img class="solfie-ad__img" src="' + capa + '" alt="' + titulo +
          '" loading="lazy" decoding="async" width="120" height="150">'
        : '<span class="solfie-ad__ph"></span>') +
      '</span>' +
      '<span class="solfie-ad__info">' +
      '<span class="solfie-ad__name">' + titulo + '</span>' +
      '<span class="solfie-ad__meta">' + precos + '</span>' +
      selo(p, v) +
      '<a class="solfie-upsell__link" href="' + p.url + '">' + esc(LINK_TEXTO) + '</a>' +
      '</span>' +
      '<span class="solfie-ad__switch" aria-hidden="true"><span class="solfie-ad__knob"></span></span>' +
      '</label>'
    );
  }

  function esqueleto(p) {
    return (
      '<div class="solfie-ad__inner">' +
      '<header class="solfie-ad__head">' +
      '<p class="solfie-ad__title">' + esc(TITULO) + '</p>' +
      (SUB ? '<p class="solfie-ad__note">' + esc(SUB) + '</p>' : '') +
      '</header>' +
      '<div class="solfie-ad__list" data-role="list">' + item(p) + '</div>' +
      '<p class="solfie-ad__status" data-role="status" role="status" aria-live="polite"></p>' +
      '</div>'
    );
  }

  /* ---------- desenho ---------- */

  function statusDe(el, txt, erro) {
    if (!el) return;
    var alvo = el.querySelector('[data-role="status"]');
    if (!alvo) return;
    alvo.textContent = txt || '';
    alvo.className = 'solfie-ad__status' + (erro ? ' is-error' : '');
  }

  function sincronizar(el) {
    var inp = el.querySelector('[data-role="toggle"]');
    if (inp) inp.checked = !!chaveDaVariante(inp.value);
  }

  function alternar(el, inp) {
    var chave = chaveDaVariante(inp.value);
    var jaTem = !!chave;
    var cabecalho = { 'Content-Type': 'application/json', Accept: 'application/json' };

    el.classList.add('is-carregando');
    statusDe(el, '', false);

    var pedido = jaTem
      ? window.fetch('/cart/change.js', {
          method: 'POST',
          headers: cabecalho,
          body: JSON.stringify({ id: chave, quantity: 0 })
        })
      : window.fetch('/cart/add.js', {
          method: 'POST',
          headers: cabecalho,
          body: JSON.stringify({ items: [{ id: Number(inp.value), quantity: 1 }] })
        });

    pedido
      .then(function (r) {
        if (!r.ok) throw new Error('falhou');
        return r.json();
      })
      .then(lerCarrinho)
      .then(function () {
        el.classList.remove('is-carregando');
        sincronizar(el);
        avisar();
        statusDe(el, jaTem ? 'Item removido do carrinho.' : 'Item adicionado ao carrinho.', false);
        window.setTimeout(function () { statusDe(el, '', false); }, 2600);
      })
      .catch(function () {
        el.classList.remove('is-carregando');
        inp.checked = jaTem;
        statusDe(el, 'Não foi possível atualizar o carrinho. Tente de novo.', true);
      });
  }

  function desenhar(montagem, p) {
    montagem.hidden = false;
    if (!montagem.querySelector('.solfie-ad__item')) {
      montagem.innerHTML = esqueleto(p);
    }
    sincronizar(montagem);

    var inp = montagem.querySelector('[data-role="toggle"]');
    if (inp && !inp.dataset.bind) {
      inp.dataset.bind = '1';
      inp.addEventListener('change', function () { alternar(montagem, inp); });
    }
  }

  /* ---------- ciclo de vida ---------- */

  function criarMontagem(id) {
    var el = document.createElement('div');
    el.className = 'solfie-ad solfie-ad--drawer';
    el.id = id;
    el.setAttribute('data-solfie-upsell', '');
    el.setAttribute('data-origem', 'carrinho');
    el.hidden = true;
    return el;
  }

  /*
   * Nada a mostrar com o carrinho vazio. O drawer ainda pode estar no estado
   * "O carrinho está vazio" (HTML do servidor de quando a pagina carregou):
   * nesse caso tambem nao desenhamos, senao a lista aparece embaixo do aviso.
   */
  function podeDesenhar(comp) {
    if (!estado.carrinho || !estado.carrinho.item_count) return false;
    if (comp && comp.querySelector('.cart-drawer__heading--empty')) return false;
    return true;
  }

  function esconder(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function render(comp, ehDrawer) {
    var id = ehDrawer ? 'solfie-ad-carrinho-drawer' : 'solfie-ad-carrinho-pagina';
    var atual = (ehDrawer ? comp : document).querySelector('#' + id);

    if (!podeDesenhar(ehDrawer ? comp : null)) {
      esconder(atual);
      return;
    }
    if (atual) {
      desenhar(atual, null);
      return;
    }
    if (estado.buscando) return;
    estado.buscando = true;

    escolherProduto()
      .then(function (p) {
        estado.buscando = false;
        if (!p) {
          esconder(document.getElementById(id));
          return;
        }

        var destino = ehDrawer
          ? comp.querySelector('.cart-drawer__items') || comp.querySelector('.cart-drawer__content')
          : comp.querySelector('.cart-page__items');

        if (!destino) return;
        if (destino.querySelector('#' + id)) return;

        var montagem = criarMontagem(id);
        /* ULTIMO filho da lista de itens (o morph do tema casa filhos por
           posicao; como irmao do resumo o widget seria fundido com ele) */
        destino.appendChild(montagem);
        desenhar(montagem, p);
      })
      .catch(function () { estado.buscando = false; });
  }

  function garantir() {
    lerCarrinho()
      .then(function () {
        document.querySelectorAll('cart-items-component').forEach(function (comp) {
          render(comp, comp.hasAttribute('data-drawer'));
        });
      })
      .catch(function () {});
  }

  function iniciar() {
    garantir();

    var agendado = null;
    function agendar() {
      if (agendado) return;
      agendado = window.setTimeout(function () { agendado = null; garantir(); }, 150);
    }
    new MutationObserver(agendar).observe(document.body, { childList: true, subtree: true });

    ['cart:add', 'cart:update', 'cart:refresh', 'cart:updated'].forEach(function (ev) {
      document.addEventListener(ev, function () { window.setTimeout(garantir, 160); });
    });
    document.addEventListener('shopify:section:load', function () { window.setTimeout(garantir, 240); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
